import { useState } from '@wordpress/element';
import { useCopyToClipboard } from '@wordpress/compose';
import { Button } from '@wordpress/components';

const { flowEW } = window;
const { i18n } = flowEW;

export default function RevisionShareBar({ url }) {
  const [copied, setCopied] = useState(false);
  const ref = useCopyToClipboard(url, () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  });

  return (
    <div className="flow-ew-share-bar">
      <p className="flow-ew-share-bar__label">{i18n.snapshotLink}</p>
      <div className="flow-ew-share-bar__row">
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          className="flow-ew-share-bar__link"
          title={url}
        >
          {url}
        </a>
        <Button
          ref={ref}
          size="compact"
          variant="tertiary"
          label={copied ? i18n.copied : i18n.copyLink}
          showTooltip
          className={`flow-ew-share-bar__copy ${copied ? 'flow-ew-share-bar__copy--done' : ''}`}
        >
          <span
            className={`dashicons ${copied ? 'dashicons-yes' : 'dashicons-admin-page'}`}
            style={{ fontSize: '16px', width: '16px', height: '16px', lineHeight: 1 }}
          />
        </Button>
      </div>
    </div>
  );
}
